import { render, staticRenderFns } from "./CorruptionUpgradeButton.vue?vue&type=template&id=a1c479ea&scoped=true&"
import script from "./CorruptionUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./CorruptionUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c479ea",
  null
  
)

export default component.exports